import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const UserViewModule = new Module({
  id: 'USER-OPERATION:VIEW:RESULT-TABLE',
  name: 'User',
  path: 'user',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Users/View'))
  ),
});

export const UserAddModule = new Module({
  id: 'USER-OPERATION:CREATE:ADD-USER',
  name: 'UserAdd',
  path: 'user/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Users/Form'))
  ),
  actions: {
    add: {
      id: 'USER-OPERATION:CREATE:ADD-USER',
      name: 'add-user',
      label: 'Add user'
    }
  }
});

export const UserEditModule = new Module({
  id: 'USER-OPERATION:EDIT:UPDATE-USER',
  name: 'UserEdit',
  path: 'user/edit',
  pathDef: 'user/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Users/Form'))
  ),
  actions: {
    edit: {
      id: 'USER-OPERATION:EDIT:USER-RESULT-TABLE',
      name: 'edit-user-result-table',
      label: 'Edit'
    },
    setNewPassword: {
      id: 'USER-OPERATION:EDIT:SET-USER-PASSWORD',
      name: 'set-user-password',
      label: 'Set New Password'
    },
    delete: {
      id: 'USER-OPERATION:DELETE:RESULT-TABLE',
      name: 'delete-user-result-table',
      label: 'Delete'
    },
    associate: {
      id: 'USER-OPERATION:EDIT:ASSOCIATE-USER',
      name: 'associate-user-result-table',
      label: 'Association'
    },
    sendMail: {
      id: 'MAIL:CREATE:MAIL-SENT',
      name: 'send-mail-item',
      label: 'Send Mail'
    }
  }
});

const UserModules = [UserViewModule, UserEditModule, UserAddModule];

export default new ModuleBundle('User', UserModules);
